import Screen from '../../../../shared/utils/screen';

function SearchButton() {
  return (
    <svg
      width={60 * Screen.widthRatio}
      height={60 * Screen.widthRatio}
      viewBox={'0 0 90 90'}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle cx='45' cy='45' r='45' fill='white' />
      <path
        d='M65.4103 62.4592L57.6239 54.73C60.6463 50.9586 62.11 46.1717 61.714 41.3535C61.318 36.5353 59.0923 32.0521 55.4948 28.8256C51.8972 25.5992 47.2011 23.8748 42.3721 24.0071C37.5431 24.1393 32.9483 26.1181 29.5324 29.5366C26.1165 32.9551 24.1392 37.5534 24.0071 42.3861C23.8749 47.2187 25.598 51.9184 28.822 55.5187C32.046 59.119 36.5258 61.3463 41.3403 61.7426C46.1548 62.1389 50.9381 60.6742 54.7066 57.6494L62.43 65.3787C62.6252 65.5756 62.8573 65.7318 63.113 65.8385C63.3688 65.9451 63.6431 66 63.9202 66C64.1972 66 64.4715 65.9451 64.7273 65.8385C64.983 65.7318 65.2152 65.5756 65.4103 65.3787C65.7886 64.9871 66 64.4637 66 63.919C66 63.3743 65.7886 62.8509 65.4103 62.4592ZM42.9326 57.6494C40.027 57.6494 37.1866 56.7872 34.7706 55.1716C32.3546 53.5561 30.4716 51.2599 29.3597 48.5734C28.2477 45.8869 27.9568 42.9307 28.5237 40.0787C29.0905 37.2267 30.4897 34.607 32.5443 32.5508C34.599 30.4947 37.2167 29.0944 40.0665 28.5271C42.9163 27.9598 45.8703 28.251 48.5547 29.3637C51.2392 30.4765 53.5337 32.361 55.148 34.7788C56.7623 37.1966 57.6239 40.0392 57.6239 42.947C57.6239 46.8463 56.0761 50.586 53.3209 53.3432C50.5658 56.1004 46.829 57.6494 42.9326 57.6494Z'
        fill='black'
      />
    </svg>
  );
}

export default SearchButton;
